import {
  SET_LOADING_DATA,
  GET_LIST_ALL_REQUEST,
  GET_LIST_ALL_SUCCESS,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SHARE_CSV,
  GET_DETAILS_REQUEST,
  GET_DETAILS_SUCCESS,
  SET_LOADING_DETAILS,
  CLEAR_DETAILS
} from './commission-report-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const getAllCommissionReportsRequest = (filters?: any) => {
  return {
    type: GET_LIST_ALL_REQUEST,
    filters
  };
};

export const getAllCommissionReportsSuccess = payload => {
  return {
    type: GET_LIST_ALL_SUCCESS,
    payload
  };
};

export const shareCSV = (payload: { exportType: string; month?: string }) => {
  return {
    type: SHARE_CSV,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const getCommissionDetailsRequest = (payload: any) => {
  return {
    type: GET_DETAILS_REQUEST,
    payload
  };
};

export const getCommissionDetailsSuccess = (payload: any[]) => {
  return {
    type: GET_DETAILS_SUCCESS,
    payload
  };
};
export const setLoadingDetails = (loading: boolean) => {
  return {
    type: SET_LOADING_DETAILS,
    loading
  };
};
export const clearCommissionDetails = () => {
  return {
    type: CLEAR_DETAILS
  };
};
